// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import BackstageVariantImageUploadController from "./backstage_variant_image_upload_controller.js"
application.register("backstage-variant-image-upload", BackstageVariantImageUploadController)

import BackstageVariantImagesController from "./backstage_variant_images_controller.js"
application.register("backstage-variant-images", BackstageVariantImagesController)

import BackstageVariantPriceController from "./backstage_variant_price_controller.js"
application.register("backstage-variant-price", BackstageVariantPriceController)

import CheckoutController from "./checkout_controller.js"
application.register("checkout", CheckoutController)

import CookiesConsentController from "./cookies_consent_controller.js"
application.register("cookies-consent", CookiesConsentController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import LineItemQuantityController from "./line_item_quantity_controller.js"
application.register("line-item-quantity", LineItemQuantityController)

import MainMenuController from "./main_menu_controller.js"
application.register("main-menu", MainMenuController)
